import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'vue-cookie'

import auth from './auth.js'
import data from './data.js'
// import post from './post.js'
// import announcement from './announcement.js'
// import event from './event.js'

import presence from './presence.js'
import tatib from './tatib.js'

import notificationLocal from './notificationLocal.js'

import studentMe from './studentMe.js'
import otp from './otp.js'

import postWp from './postWp.js'
import announcementWp from './announcementWp.js'
import eventWp from './eventWp.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: cookie.get('token_parent'),
        username: cookie.get('user_parent') ? JSON.parse(cookie.get('user_parent')).username : "",
        student_name: cookie.get('student_name'),
        student_image: cookie.get('student_image'),
        student_classroom: cookie.get('student_classroom'),
        errors: {},
        success: '',
        loading: true
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload
        },
        SET_ERRORS(state, payload) {
            state.errors = payload
        },
        CLEAR_ERRORS(state) {
            state.errors = {}
        },
        SET_SUCCESS(state, payload) {
            state.success = payload
        },
        CLEAR_SUCCESS(state) {
            state.success = ''
        },
        SET_USERNAME(state, payload) {
            state.username = payload
        },
        SET_STUDENT_NAME(state, payload) {
            state.student_name = payload
        },
        SET_STUDENT_IMAGE(state, payload) {
            state.student_image = payload
        },
        SET_STUDENT_CLASSROOM(state, payload) {
            state.student_classroom = payload
        },
        SET_LOADING(state) {
            state.loading = true
        },
        CLEAR_LOADING(state) {
            state.loading = false
        }
    },
    actions: {
        forceLogout({ state }) {
            state.token = null
            cookie.delete('token_parent')
            cookie.delete('user_parent')
            cookie.delete('student_name')
            cookie.delete('student_image')
            cookie.delete('student_classroom')
        }
    },
    getters: {
        isAuth: state => {
            return state.token != "null" && state.token != null
        }
    },
    modules: {
        auth, 
        data, 
        // post, 
        // announcement, 
        // event, 
        presence, 
        tatib, 
        notificationLocal, 
        studentMe, 
        otp, 
        postWp,
        announcementWp,
        eventWp,
    }
})